import { Dispatch, SetStateAction, useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Determines if the element is in viewport
 * @example
 * const isInViewport = useInViewport(domElement)
 * @param {Object} domElement React Ref object
 * @param {string} containerId Id of the container element
 * @returns {boolean} Return true | false
 */

export const useInViewport = (domElement: any, containerId: string) => {
  const [isIntersecting, setIntersecting] = useState(false);
  const options = {
    root: document.querySelector(`#${containerId}`),
    rootMargin: '0px',
    threshold: 0.5,
  };
  // Observer to detect if the element is in viewport
  const observer = useMemo(
    () => new IntersectionObserver(([entry]: any) => setIntersecting(entry.isIntersecting), options),
    [domElement]
  );

  useEffect(() => {
    // Observe the element only once
    if (!isIntersecting) {
      observer.observe(domElement.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [isIntersecting]);

  return isIntersecting;
};

/**
 * Delay Function
 * @example
 * await delay(1000)
 * @param {number} time Value in milliseconds
 * @returns {Promise} Returns resolved promise indication timeout completion
 */
export const delay = (time: number) => new Promise((resolve) => setTimeout(resolve, time));

// /**
//  * useLocationStorage Hook
//  * @example
//  * @param {string} key Value to store in localStorage
//  * @param {Type} initialValue The initial value to set the key to
//  * @returns {Array} Returns value for local storage key and a function to update the value
//  */

// export function useLocalStorage<Type>(key: string, initialValue?: Type) {
//   const [value, setValue] = useState(() => {
//     try {
//       const item = window.localStorage.getItem(key);
//       return item ? JSON.parse(item) : initialValue;
//     } catch (error) {
//       console.log(error);
//       return initialValue;
//     }
//   });

//   const setStoredValue = useCallback(
//     (val: React.Dispatch<React.SetStateAction<Type>>) => {
//       try {
//         const valueToStore = val instanceof Function ? val(value) : val;
//         window.localStorage.setItem(key, JSON.stringify(valueToStore));
//       } catch (error) {
//         console.log(error);
//       }
//     },
//     [value, key]
//   );

//   useEffect(() => {
//     setStoredValue(value);
//   }, [value, setStoredValue]);

//   return [value, setValue];
// }
